
import React from 'react';
import { Link } from 'react-router-dom';

type HeroButtonsProps = {
  buttonText?: string;
  buttonLink?: string;
  onButtonClick?: () => void;
  secondaryButtonText?: string;
  secondaryButtonLink?: string;
  secondaryButtonIcon?: React.ReactNode;
  contentPosition?: 'center' | 'left' | 'right';
};

const HeroButtons: React.FC<HeroButtonsProps> = ({
  buttonText,
  buttonLink,
  onButtonClick,
  secondaryButtonText,
  secondaryButtonLink,
  secondaryButtonIcon,
  contentPosition = 'center',
}) => {
  if (!buttonText && !secondaryButtonText) return null;
  
  return (
    <div 
      className={`
        flex flex-col sm:flex-row gap-4 mt-6 md:mt-8 hero-button-container
        ${contentPosition === 'center' ? 'justify-center' : ''}
        ${contentPosition === 'left' ? 'justify-start' : ''}
        ${contentPosition === 'right' ? 'justify-end' : ''}
      `}
    >
      {buttonText && (buttonLink || onButtonClick) && (
        <>
          {buttonLink ? (
            <Link 
              to={buttonLink} 
              className="bg-[#F97316] text-white hover:text-white inline-flex items-center gap-2 px-8 py-4 rounded-lg transition-all duration-300 hover:-translate-y-1 hover:shadow-lg text-lg font-medium min-w-[200px] justify-center"
              onClick={onButtonClick}
            >
              {buttonText}
            </Link>
          ) : (
            <button 
              onClick={onButtonClick} 
              className="bg-[#F97316] text-white hover:text-white inline-flex items-center gap-2 px-8 py-4 rounded-lg transition-all duration-300 hover:-translate-y-1 hover:shadow-lg text-lg font-medium min-w-[200px] justify-center"
            >
              {buttonText}
            </button>
          )}
        </>
      )}
      
      {secondaryButtonText && secondaryButtonLink && (
        <Link 
          to={secondaryButtonLink} 
          className="bg-white text-[#F97316] hover:text-[#F97316] border border-[#F97316] inline-flex items-center gap-2 px-8 py-4 rounded-lg transition-all duration-300 hover:-translate-y-1 hover:shadow-lg text-lg font-medium min-w-[200px] justify-center"
        >
          {secondaryButtonIcon}
          {secondaryButtonText}
        </Link>
      )}
    </div>
  );
};

export default HeroButtons;
